import { render, staticRenderFns } from "./reportStyle2.vue?vue&type=template&id=0448a568&scoped=true"
import script from "./reportStyle2.vue?vue&type=script&lang=js"
export * from "./reportStyle2.vue?vue&type=script&lang=js"
import style0 from "./reportStyle2.vue?vue&type=style&index=0&id=0448a568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0448a568",
  null
  
)

export default component.exports